import { Dialog, DialogActions, DialogContent, DialogContentText, Link, Typography } from "@mui/material";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { StyledButtonUplodBasket } from "./BasketUpload.style";
import { useExcelUtility } from "../../../../explorer/utils/ExcelUtils";
import CommonDialog from "../../CommonDialog/CommonDialog";

export const DialogDownloadTemplate: React.FC<{
    importErrorDialogOpen: any;
    handleImportErrorDialogClose: any;
    handleExportTemplate: any;
}> = ({
    importErrorDialogOpen,
    handleImportErrorDialogClose,
    handleExportTemplate,
}) => {
    const { t } = useTranslation();

    return (
        <CommonDialog
            open={importErrorDialogOpen}
            closeDialog={handleImportErrorDialogClose}
            dialogTitleLabel="alert.title.warning"
            useDenyBtn={false}
            confirmButtonText={"common.ok"}
            confirmButton={handleImportErrorDialogClose}
        >
            <>
                <Typography id="alert-dialog-description">
                    {t("common.spareparts.basket.upload.upload_xls")}
                </Typography>
                <Link
                    href="#"
                    color="primary"
                    variant="body1"
                    style={{ marginLeft: "10px" }}
                    onClick={(event: any) => {
                        event.preventDefault();
                        event.stopPropagation();
                        handleExportTemplate();
                        return false;
                    }}
                >
                    {t("common.spareparts.basket.upload.download_template_xls")}
                </Link>
            </>
        </CommonDialog>
    );
};